import { Card, Statistic, Row, Col } from "antd"

export function SummaryCard({ summary }) {
  if (!summary) return null

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Row gutter={[24, 16]}>
        <Col xs={12} sm={8} md={Math.floor(24 / 5)}>
          <Statistic
            title="Сумма заказов"
            value={summary.ordersTotal}
            precision={2}
            suffix="₽"
          />
        </Col>
        <Col xs={12} sm={8} md={Math.floor(24 / 5)}>
          <Statistic
            title="Оплачено в банке"
            value={summary.paidInBank}
            precision={2}
            suffix="₽"
          />
        </Col>
        <Col xs={12} sm={8} md={Math.floor(24 / 5)}>
          <Statistic
            title="Возвраты"
            value={summary.refunds}
            precision={2}
            suffix="₽"
            valueStyle={{ color: summary.refunds > 0 ? "#cf1322" : undefined }}
          />
        </Col>
        <Col xs={12} sm={8} md={Math.floor(24 / 5)}>
          <Statistic
            title="Итого банк"
            value={summary.bankTotal}
            precision={2}
            suffix="₽"
          />
        </Col>
        <Col xs={12} sm={8} md={Math.floor(24 / 5)}>
          <Statistic
            title="Разница"
            value={summary.difference}
            precision={2}
            suffix="₽"
            valueStyle={{
              color:
                summary.difference > 0
                  ? "#cf1322"
                  : summary.difference < 0
                    ? "#3f8600"
                    : undefined,
            }}
          />
        </Col>
      </Row>
    </Card>
  )
}
